// extracted by mini-css-extract-plugin
module.exports = {"care-icon":"index-module_care-icon_13FKB"};